import { render, staticRenderFns } from "./PartsChooser.vue?vue&type=template&id=1f97716d"
import script from "./PartsChooser.vue?vue&type=script&lang=ts"
export * from "./PartsChooser.vue?vue&type=script&lang=ts"
import style0 from "./PartsChooser.vue?vue&type=style&index=0&id=1f97716d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports